import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphQLClient } from "../../shared/services/graph-qlclient.service";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { SecurityService } from "../../shared/services/security.service";
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { formato } from 'src/app/shared/object/formato.model';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import gql from "graphql-tag";
import { without } from 'lodash';
import { TabsetComponent, ToastService } from 'ng-uikit-pro-standard';


@Component({
  selector: 'app-formatos',
  templateUrl: './formatos.component.html',
  styleUrls: ['./formatos.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class FormatosComponent implements OnInit {
  private client: GraphQLClient = null;
  public formFormato: FormGroup;
  public formBusqueda: FormGroup;
  public formatoList: formato[];
  public formatoSel: formato;


  @ViewChild('agregarFormato', { static: true }) agregarModal: ModalDirective;

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    public toastService: ToastService,
  ) {
    this.client = client;
    this.formFormato = this.construyeForm();
    this.formBusqueda = this.construyeFormBusqueda();
  }

  construyeFormBusqueda() {
    return new FormGroup({
      codigo: new FormControl("")
    });
  }

  construyeForm() {
    return new FormGroup({
      codigo: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(5)]),
      nombre: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(20)]),
      cantidad: new FormControl("", [Validators.required]),
      formatopadre: new FormControl(""),
      esCompra: new FormControl(true),
      esVenta: new FormControl(true),
      esEdicion: new FormControl(false)
    });


  }

  showForEdit(sel_formato: formato) {
    this.formFormato.reset();
    this.formatoSel = Object.assign({}, sel_formato);
    this.f.codigo.setValue(sel_formato.codigo);
    this.f.nombre.setValue(sel_formato.nombre);
    this.f.cantidad.setValue(sel_formato.cantidad);
    this.f.esCompra.setValue(sel_formato.es_compra);
    this.f.esVenta.setValue(sel_formato.es_venta);
    this.f.esEdicion.setValue(true);
    this.f.codigo.disable();
  }

  showForNew() {
    this.formFormato.reset();
    this.f.esEdicion.setValue(false);
    this.f.codigo.enable();
  }


  ValidaQueExisteDatosFormato() {
    let self = this; // this is unused

    this.formatoSel = {
      codigo: this.f.codigo.value.toUpperCase(),
      cantidad: this.f.cantidad.value,
      empresa_rut: this.accesolocalstorage.getRutEmpresa(),
      es_compra: this.f.esCompra.value,
      es_venta: this.f.esVenta.value,
      fecha_registro: new Date,
      formato_padre: "",
      nombre: this.f.nombre.value,
      rut_usuario_creacion: this.accesolocalstorage.getRutUsuario(),
      rut_usuario_modificacion: this.accesolocalstorage.getRutUsuario()
    };

    // Si estamos editando, ir directamente a guardar
    if (this.f.esEdicion.value == true) {
      self.guardarFormato(self.formatoSel);
    }
    else {
      // Si estamos agregando, verificar si existe antes de guardar
      this.client.query(
        {
          query: gql`
            query($entidad: formatoInputType) {
              formato {
                existe(entidad: $entidad) {
                  respuesta
                }
              }
            }
          `,
          fetchPolicy: "network-only",
          variables: {
            entidad: this.formatoSel,
          },
        },
        function (respuesta) {
          if (respuesta.data.formato.existe.respuesta) {
            // El código ya existe, no se puede agregar
            self.toastService.warning("El código de formato ya existe");
          }
          else {
            // El código no existe, se puede agregar
            self.guardarFormato(self.formatoSel);
          }
        }
      );
    }



  }


  buscaFormato() {

    this.obtenerFormatos(this.accesolocalstorage.getRutEmpresa(),
      "",
      this.fBus.codigo.value);
  }

  guardarFormato(formatoRegistro: formato) {
    let self = this;
    var bodyx = formatoRegistro;

    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: formatoInputType) {
            formato {
              guardar(entidad: $entidad) {
                respuesta {
                  empresa_rut
                  codigo
                  nombre
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {

        if (respuesta.data.formato.guardar.respuesta == null) {
          if (respuesta.data.formato.guardar.mensajes.length > 0) {
            self.toastService.error(respuesta.data.formato.guardar.mensajes[0].texto);
          }
        }
        else {
          self.toastService.info("Registro grabado");
        }

        setTimeout(
          () =>
            self.buscaFormato(),
          1000
        );
      }
    );
  }


  obtenerFormatos(rutEmpresa: number, nombreFormato: string, codigoFormato: string) {
    let self = this;
    if (codigoFormato === "") {
      codigoFormato = "-1";
    }

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $nombre: String, $codigo: String)
          {
            formato{
              obtenerSegunFiltro(filtro:{
                exacto:{
                  empresa_rut: $rutEmpresa
                  nombre: $nombre
                  codigo: $codigo
                }
              })
              {
                mensajes
                {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta
                {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros{
                    empresa_rut
                    codigo
                    nombre
                    cantidad
                    formato_padre
                    fecha_registro
                    rut_usuario_creacion
                    rut_usuario_modificacion
                    es_compra
                    es_venta
                  }
                }
              }
            }
          }
          `,
        fetchPolicy: "no-cache",
        variables: {
          rutEmpresa: rutEmpresa,
          nombre: nombreFormato,
          codigo: codigoFormato
        }

      },
      function (respuesta) {
        self.formatoList = respuesta.data.formato.obtenerSegunFiltro.respuesta.registros;
      }
    );

  }

  // optionsFormatoPadre: Array<any> = [];

  ngOnInit() {

    this.buscaFormato();

  }

  get f() { return this.formFormato.controls; }
  get fBus() { return this.formBusqueda.controls; }


}
